import { render, staticRenderFns } from "./ApproveDatacorrection.vue?vue&type=template&id=301c675e"
import script from "./ApproveDatacorrection.vue?vue&type=script&lang=js"
export * from "./ApproveDatacorrection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports